import React from 'react';

const CartSummary = ({
  calculateTotal,
  discount,
  onDiscountChange,
  calculateTotalWithDiscount,
  loading,
  onCheckout,
  onPrintTicket
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white p-3 shadow-2xl border-t border-gray-200">
      <div className="max-w-4xl mx-auto">
        {/* Total principal */}
        <div className="flex justify-between items-center mb-3">
          <span className="text-5xl font-bold text-gray-800">Total:</span>
          {discount > 0 ? (
            <div className="text-right">
              <div className="text-5xl text-gray-500 line-through">
                ${calculateTotal()}
              </div>
              <div className="text-5xl font-bold text-red-500">
                ${calculateTotalWithDiscount()}
              </div>
            </div>
          ) : (
            <span className="text-5xl font-bold text-green-600">
              ${calculateTotal()}
            </span>
          )}
        </div>

        {/* Fila con descuento y botón */}
        <div className="flex gap-3 items-end">
          {/* Campo de descuento compacto */}
          <div className="flex-1">
            <label className="block text-gray-700 font-medium mb-1 text-sm">
              Descuento ($)
            </label>
            <input
              type="number"
              value={discount}
              onChange={onDiscountChange}
              className="w-full p-2 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="0"
              min="0"
              max={calculateTotal()}
            />
          </div>
          <button
            type="button"
            onClick={onPrintTicket}
            disabled={loading}
            className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-base font-bold transition-colors duration-200 shadow-lg"
          >
            {loading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Procesando...</span>
              </div>
            ) : (
              'Imprimir ticket'
            )}
          </button>
          {/* Botón de confirmar venta */}
          <button
            onClick={onCheckout}
            disabled={loading}
            className="flex-1 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed text-base font-bold transition-colors duration-200 shadow-lg"
          >
            {loading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Procesando...</span>
              </div>
            ) : (
              '🛍️ Confirmar Venta'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
